import {type PaletteOptions} from '@mui/material/styles';
import {blueGrey} from '@mui/material/colors';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    light: '#2b76f5',
    main: '#1366f4',
    dark: '#0d47aa',
    contrastText: '#fff',
  },
  secondary: {
    main: '#415B78',
    light: '#6082A9',
  },
  text: {
    primary: '#435B75',
    secondary: '#526f8e',
    disabled: '#8097B1',
  },
  action: {},
  background: {
    default: '#F4F6FC',
    paper: '#ffffff',
  },
  error: {
    dark: '#D5190B',
    main: '#f44336',
    light: '#F76E64',
  },
  warning: {
    dark: '#C56300',
    main: '#F26800',
    light: '#F7C137',
    contrastText: '#ffffff',
  },
  info: {
    main: '#1365F4',
    dark: '#0A55D6',
    light: '#3C80F6',
  },
  success: {
    dark: '#388E3C',
    main: '#66BB6A',
    light: '#81C784',
  },
  good: {
    main: '#77EEB6',
  },
  bad: {
    main: '#FF8E93',
  },
  neutral: {
    main: '#CFD8D7',
  },
  input: {
    main: '#ade0d9',
  },
  harvest: {
    main: '#F7C137',
  },
  transfer: {
    main: '#faa7a7',
  },
  delousing: {
    main: '#8B45A3',
  },
  tableViewBackgroundColor: {
    main: '#E0E0E0',
    light: '#FEFEFE',
    dark: '#F5F5F5',
  },
  graph: {
    main: blueGrey[200],
    light: blueGrey[100],
    dark: blueGrey[300],
  },
};
